export default "__VITE_ASSET__CHHSqJCE__"